import {
  ContainerPopper,
  ExtendedGridColumnHeaderProps,
  FakeDropdownBox,
  IssueEntityNameMultipleSelector,
  TransformedIssueEntityNameDto,
  useDataGridContext,
} from '@issuemanager/apps/client/components';
import { useEventCallback } from '@mui/material';

export function DataGridIssueEntityNameFilter(
  params: ExtendedGridColumnHeaderProps,
) {
  const context = useDataGridContext();
  const value: TransformedIssueEntityNameDto[] =
    context.filterModel[params.field] ?? [];

  const handleChange = useEventCallback((value) => {
    context.setFilterModel((prevState) => ({
      ...prevState,
      [params.field]: value,
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length > 0
            ? value.map((entity) => entity.name).join(', ')
            : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <IssueEntityNameMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
